<template>
    {{ canvasWidth + "hi" + canvasHeight}}
    <div class="signature-pad">
        <div class="signature-pad-container">
          <canvas
            :id="'signatureCanvas' + unique"
            :width=width
            :height=height
            @mousedown="startDrawing"
            @mouseup="stopDrawing"
            @mousemove="draw"
          ></canvas>
        </div>
        <div class="signature-pad-upload-button">
          <p class="clear-button" @click="clearSignature">Clear</p>
          <div>
            <hlx-button class="secondary sm Cancel" @click="closeModal"
              >Cancel</hlx-button
            >
            <hlx-button class="primary sm Upload" @click="getSignature"
              >Sign</hlx-button
            >
          </div>
        </div>
      </div> 
</template>

<script>
export default {
    props:{
    height:{
     type:String,
     default:'300'
    },
    width:{
    type:String,
    default:'629'
    }
    },
data(){
    return{
        canvasWidth:"",
        canvasHeight:""
    }
    
},
watch:{
    width:{
        handler(val){
            this.canvasWidth=val
        }
    },
    height:{
        handler(val){
            this.canvasHeight=val
        }
    }
},
methods:{
    startDrawing(event) {
      this.isDrawing = true;
      const canvas = document.getElementById("signatureCanvas" + this.unique);
      this.ctx = canvas.getContext("2d");
      const x = event.clientX - canvas.getBoundingClientRect().left;
      const y = event.clientY - canvas.getBoundingClientRect().top;
      this.ctx.beginPath();
      this.ctx.moveTo(x, y);
    },
    stopDrawing() {
      this.isDrawing = false;
      this.ctx.closePath();
    },
    draw(event) {
      if (!this.isDrawing) return;
      const canvas = document.getElementById("signatureCanvas" + this.unique);
      const x = event.clientX - canvas.getBoundingClientRect().left;
      const y = event.clientY - canvas.getBoundingClientRect().top;
      this.ctx.lineTo(x, y);
      this.ctx.stroke();
    },
    clearSignature() {
      const canvas = document.getElementById("signatureCanvas" + this.unique);
      this.ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.duplicateSignatureData = null;
    },
}
}
</script>

<style>

</style>